/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { getTheme, IButtonStyles } from "@fluentui/react";

const theme = getTheme();

/**
 * Styles for the icon button used within the modal
 */
export const reviewStatusButtonStyles: IButtonStyles = {
  root: {
    backgroundColor: theme.palette.neutralSecondaryAlt,
    border: "none",
    borderRadius: "4px",
    color: theme.palette.white,
    fontSize: "12px",
    padding: "4px 6px",
  },
  rootDisabled: {
    backgroundColor: theme.palette.neutralSecondaryAlt,
    color: theme.palette.white,
  },
};

export const activeReviewStatusButtonStyles: IButtonStyles = {
  root: {
    backgroundColor: theme.palette.themePrimary,
    border: "none",
    borderRadius: "4px",
    color: theme.palette.white,
    fontSize: "12px",
    padding: "4px 6px",
  },
};
